import { RemoteGetPerformanceReportForProfessionalsEvolution } from 'data/usecases';
import { GetPerformanceReportForProfessionalsEvolutionUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerformanceReportForProfessionalsEvolution } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetPerformanceReportForProfessionalsEvolution =
  (): GetPerformanceReportForProfessionalsEvolutionUseCaseInterface =>
    new RemoteGetPerformanceReportForProfessionalsEvolution(
      makeApiUrlPerformanceReportForProfessionalsEvolution(),
      makeAxiosHttpClient(),
    );
